tinymce.addI18n("nl_BE", {
    "#": "#",
    "Accessibility": "Toegankelijkheid",
    "Accordion": "",
    "Accordion body...": "",
    "Accordion summary...": "",
    "Action": "Actie",
    "Activity": "Activiteit",
    "Address": "Adres",
    "Advanced": "Geavanceerd",
    "Align": "Aligneer",
    "Align center": "Centreren",
    "Align left": "Links uitlijnen",
    "Align right": "Rechts uitlijnen",
    "Alignment": "Uitlijning",
    "Alignment {0}": "",
    "All": "Alle",
    "Alternative description": "Alternatieve beschrijving",
    "Alternative source": "Alternatieve bron",
    "Alternative source URL": "Alternatieve bron URL",
    "Anchor": "Anker",
    "Anchor...": "Anker...",
    "Anchors": "Ankers",
    "Animals and Nature": "Dieren en natuur",
    "Arrows": "Pijlen",
    "B": "B",
    "Background color": "Achtergrondkleur",
    "Background color {0}": "",
    "Black": "Zwart",
    "Block": "Vierkant",
    "Block {0}": "",
    "Blockquote": "Citaat",
    "Blocks": "Blokken",
    "Blue": "Blauw",
    "Blue component": "Blauw component",
    "Body": "Hoofdtekst",
    "Bold": "Vet",
    "Border": "Rand",
    "Border color": "Randkleur",
    "Border style": "Randstijl",
    "Border width": "Randbreedte",
    "Bottom": "Onder",
    "Browse files": "",
    "Browse for an image": "Een afbeelding zoeken",
    "Browse links": "",
    "Bullet list": "Ongeordende lijst",
    "Cancel": "Annuleren",
    "Caption": "Bijschrift",
    "Cell": "Cel",
    "Cell padding": "Celopvulling",
    "Cell properties": "Celeigenschappen",
    "Cell spacing": "Celafstand",
    "Cell styles": "Cel stijlen",
    "Cell type": "Celtype",
    "Center": "Midden",
    "Characters": "Karakters",
    "Characters (no spaces)": "Karakters (zonder spaties)",
    "Circle": "Cirkel",
    "Class": "Class",
    "Clear formatting": "Opmaak verwijderen",
    "Close": "Sluiten",
    "Code": "Broncode",
    "Code sample...": "Codevoorbeeld...",
    "Code view": "Codeweergave",
    "Color Picker": "Kleurenkiezer",
    "Color swatch": "Kleurenstaal",
    "Cols": "Kolommen",
    "Column": "Kolom",
    "Column clipboard actions": "Rij klembord acties",
    "Column group": "Kolomgroep",
    "Column header": "Kolom kop",
    "Constrain proportions": "Verhoudingen begrenzen",
    "Copy": "Kopi\xebren",
    "Copy column": "Kopieer kolom",
    "Copy row": "Rij kopi\xebren",
    "Could not find the specified string.": "Kon de gespecificeerde string niet vinden.",
    "Could not load emojis": "Kan de emoji's niet laden",
    "Count": "Tellen",
    "Currency": "Valuta",
    "Current window": "Huidig venster",
    "Custom color": "Aangepaste kleur",
    "Custom...": "Aangepast...",
    "Cut": "Knippen",
    "Cut column": "Knip kolom",
    "Cut row": "Rij knippen",
    "Dark Blue": "Donker Blauw",
    "Dark Gray": "Donker Grijs",
    "Dark Green": "Donker groen",
    "Dark Orange": "Donker Oranje",
    "Dark Purple": "Donker Paars",
    "Dark Red": "Donker Rood",
    "Dark Turquoise": "Donker turkoois",
    "Dark Yellow": "Donker Geel",
    "Dashed": "Onderbroken",
    "Date/time": "Datum/tijd",
    "Decrease indent": "Inspringing verkleinen",
    "Default": "Standaard",
    "Delete accordion": "",
    "Delete column": "Kolom verwijderen",
    "Delete row": "Rij verwijderen",
    "Delete table": "Tabel verwijderen",
    "Dimensions": "Afmetingen",
    "Disc": "Schijf",
    "Div": "Div",
    "Document": "Document",
    "Dotted": "Gestippeld",
    "Double": "Dubbel",
    "Drop an image here": "Plaats hier een afbeelding",
    "Dropped file type is not supported": "Gesleepte bestandstype wordt niet ondersteund",
    "Edit": "Bewerken",
    "Embed": "Insluiten",
    "Emojis": "Emoji's",
    "Emojis...": "Emoji's...",
    "Error": "Fout",
    "Error: Form submit field collision.": "Fout: Veldconflict bij versturen formulier.",
    "Error: No form element found.": "Fout: Geen formulierelement gevonden.",
    "Extended Latin": "Latijn uitgebreid",
    "Failed to initialize plugin: {0}": "Plug-in initialiseren niet gelukt: {0}",
    "Failed to load plugin url: {0}": "Plug-in URL laden niet gelukt: {0}",
    "Failed to load plugin: {0} from url {1}": "Plug-in laden niet gelukt: {0} vanaf url {1}",
    "Failed to upload image: {0}": "Afbeelding uploaden niet gelukt: {0}",
    "File": "Bestand",
    "Find": "Zoeken",
    "Find (if searchreplace plugin activated)": "Zoeken (als zoeken/vervangen plug-in geactiveerd is)",
    "Find and Replace": "Zoeken en Vervangen",
    "Find and replace...": "Zoeken en vervangen...",
    "Find in selection": "Zoeken in selectie",
    "Find whole words only": "Enkel volledige woorden",
    "Flags": "Vlaggen",
    "Focus to contextual toolbar": "Focus naar contextuele werkbalk",
    "Focus to element path": "Focus naar elementenpad",
    "Focus to menubar": "Focus naar menubalk",
    "Focus to toolbar": "Focus naar werkbalk",
    "Font": "Lettertype",
    "Font size {0}": "",
    "Font sizes": "Lettergroottes",
    "Font {0}": "",
    "Fonts": "Lettertypen",
    "Food and Drink": "Voedsel en drank",
    "Footer": "Voettekst",
    "Format": "Formaat",
    "Format {0}": "",
    "Formats": "Formaten",
    "Fullscreen": "Schermvullend",
    "G": "G",
    "General": "Algemeen",
    "Gray": "Grijs",
    "Green": "Groen",
    "Green component": "Groen component",
    "Groove": "Groef",
    "Handy Shortcuts": "Handige snelkoppelingen",
    "Header": "Koptekst",
    "Header cell": "Koptekstcel",
    "Heading 1": "Hoofding 1",
    "Heading 2": "Hoofding 2",
    "Heading 3": "Hoofding 3",
    "Heading 4": "Hoofding 4",
    "Heading 5": "Hoofding 5",
    "Heading 6": "Hoofding 6",
    "Headings": "Hoofdingen",
    "Height": "Hoogte",
    "Help": "Help",
    "Hex color code": "Hex kleurcode",
    "Hidden": "Verborgen",
    "Horizontal align": "Horizontaal uitlijnen",
    "Horizontal line": "Horizontale lijn",
    "Horizontal space": "Horizontale ruimte",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID moet beginnen met een letter en daarna enkel gevolgd door letters, getallen, streepjes, punten, komma's of underscores.",
    "Image is decorative": "Afbeelding is decoratief",
    "Image list": "Afbeeldingenlijst",
    "Image title": "Afbeeldingstitel",
    "Image...": "Afbeelding...",
    "ImageProxy HTTP error: Could not find Image Proxy": "ImageProxy HTTP fout: Kan geen Image Proxy vinden",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "ImageProxy HTTP fout: Incorrecte Image proxy URL",
    "ImageProxy HTTP error: Rejected request": "ImageProxy HTTP fout: Aanvraag afgewezen",
    "ImageProxy HTTP error: Unknown ImageProxy error": "ImageProxy HTTP fout: Onbekende ImageProxy fout",
    "Increase indent": "Inspringing vergroten",
    "Inline": "In tekstregel",
    "Insert": "Invoegen",
    "Insert Template": "Sjabloon invoegen",
    "Insert accordion": "",
    "Insert column after": "Kolom invoegen na",
    "Insert column before": "Kolom invoegen voor",
    "Insert date/time": "Datum/tijd invoegen",
    "Insert image": "Afbeelding invoegen",
    "Insert link (if link plugin activated)": "Link invoegen (als link plug-in geactiveerd is)",
    "Insert row after": "Rij onder invoegen",
    "Insert row before": "Rij boven invoegen",
    "Insert table": "Tabel invoegen",
    "Insert template...": "Sjabloon invoegen...",
    "Insert video": "Video invoegen",
    "Insert/Edit code sample": "Codevoorbeeld invoegen/bewerken",
    "Insert/edit image": "Afbeelding invoegen/bewerken",
    "Insert/edit link": "Link invoegen/bewerken",
    "Insert/edit media": "Media invoegen/bewerken",
    "Insert/edit video": "Video invoegen/bewerken",
    "Inset": "Inzet",
    "Invalid hex color code: {0}": "Onjuiste hex kleurcode: {0}",
    "Invalid input": "Ongeldige invoer",
    "Italic": "Cursief",
    "Justify": "Distribueren",
    "Keyboard Navigation": "Toetsenbord navigatie",
    "Language": "Taal",
    "Learn more...": "Leer meer...",
    "Left": "Links",
    "Left to right": "Links naar rechts",
    "Light Blue": "Licht Blauw",
    "Light Gray": "Lichtgrijs",
    "Light Green": "Licht Groen",
    "Light Purple": "Licht Paars",
    "Light Red": "Licht Rood",
    "Light Yellow": "Licht Geel",
    "Line height": "Regelhoogte",
    "Link list": "Link lijst",
    "Link...": "Link...",
    "List Properties": "Lijst Eigenschappen",
    "List properties...": "Lijst eigenschappen...",
    "Loading emojis...": "Emoji's laden...",
    "Loading...": "Laden...",
    "Lower Alpha": "Kleine letters",
    "Lower Greek": "Klein Grieks schrift",
    "Lower Roman": "Klein Latijns schrift",
    "Match case": "Hoofdlettergevoelig",
    "Mathematical": "Wiskundig",
    "Media poster (Image URL)": "Mediaposter (Afbeelding URL)",
    "Media...": "Media...",
    "Medium Blue": "Middelblauw",
    "Medium Gray": "Middel Grijs",
    "Medium Purple": "Middelpaars",
    "Merge cells": "Cellen samenvoegen",
    "Middle": "Midden",
    "Midnight Blue": "Middernachtblauw",
    "More...": "Meer...",
    "Name": "Naam",
    "Navy Blue": "Marineblauw",
    "New document": "Nieuw document",
    "New window": "Nieuw venster",
    "Next": "Volgende",
    "No": "Nee",
    "No alignment": "Geen uitlijning",
    "No color": "Geen kleur",
    "Nonbreaking space": "Vaste spatie",
    "None": "Geen",
    "Numbered list": "Geordende lijst",
    "OR": "OF",
    "Objects": "Voorwerpen",
    "Ok": "OK",
    "Open help dialog": "Helpdialoog openen",
    "Open link": "Link openen",
    "Open link in...": "Link openen in...",
    "Open popup menu for split buttons": "Open pop-up menu voor gesplitste knoppen",
    "Orange": "Oranje",
    "Outset": "Uitzet",
    "Page break": "Pagina-einde",
    "Paragraph": "Paragraaf",
    "Paste": "Plakken",
    "Paste as text": "Plakken als tekst",
    "Paste column after": "Plak kolom na",
    "Paste column before": "Plak kolom voor",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Plakken is nu in gewone tekst modus. Elementen zullen nu als gewone tekst geplakt worden tot u deze optie uit schakelt.",
    "Paste or type a link": "Link plakken of typen",
    "Paste row after": "Rij onder plakken",
    "Paste row before": "Rij boven plakken",
    "Paste your embed code below:": "Plak de in te sluiten code hieronder:",
    "People": "Mensen",
    "Plugins": "Plug-ins",
    "Plugins installed ({0}):": "Ge\xefnstalleerde plugins ({0}):",
    "Powered by {0}": "Aangedreven door {0}",
    "Pre": "Pre",
    "Preferences": "Voorkeuren",
    "Preformatted": "Gepreformateerd",
    "Premium plugins:": "Premium plug-ins:",
    "Press the Up and Down arrow keys to resize the editor.": "",
    "Press the arrow keys to resize the editor.": "",
    "Press {0} for help": "",
    "Preview": "Voorbeeld",
    "Previous": "Vorige",
    "Print": "Afdrukken",
    "Print...": "Afdrukken...",
    "Purple": "Paars",
    "Quotations": "Citaten",
    "R": "R",
    "Range 0 to 255": "Bereik 0 tot 255",
    "Red": "Rood",
    "Red component": "Rood component",
    "Redo": "Opnieuw doen",
    "Remove": "Verwijderen",
    "Remove color": "Kleur verwijderen",
    "Remove link": "Link verwijderen",
    "Replace": "Vervangen",
    "Replace all": "Alles vervangen",
    "Replace with": "Vervangen door",
    "Resize": "Herschalen",
    "Restore last draft": "Laatste concept herstellen",
    "Reveal or hide additional toolbar items": "",
    "Rich Text Area": "Rich-text Gebied",
    "Rich Text Area. Press ALT-0 for help.": "Rich Text Area. Druk op Alt-0 voor help.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Rich Text Area. Druk op Alt-F9 voor menu. Druk op Alt-F10 voor gereedschapsbalk. Druk op Alt-0 voor help",
    "Ridge": "Ribbel",
    "Right": "Rechts",
    "Right to left": "Rechts naar links",
    "Row": "Rij",
    "Row clipboard actions": "Rij klembord acties",
    "Row group": "Rijgroep",
    "Row header": "Rij kop",
    "Row properties": "Rijeigenschappen",
    "Row type": "Rijtype",
    "Rows": "Rijen",
    "Save": "Opslaan",
    "Save (if save plugin activated)": "Opslaan (als opslaan plug-in geactiveerd is)",
    "Scope": "Bereik",
    "Search": "Zoeken",
    "Select all": "Alles selecteren",
    "Select...": "Selecteren...",
    "Selection": "Selectie",
    "Shortcut": "Snelkoppeling",
    "Show blocks": "Blokken tonen",
    "Show caption": "Bijschrift tonen",
    "Show invisible characters": "Onzichtbare tekens tonen",
    "Size": "Grootte",
    "Solid": "Ononderbroken",
    "Source": "Bron",
    "Source code": "Broncode",
    "Special Character": "Speciale tekens",
    "Special character...": "Speciaal karakter...",
    "Split cell": "Cel splitsen",
    "Square": "Vierkant",
    "Start list at number": "Begin lijst bij nummer",
    "Strikethrough": "Doorstreept",
    "Style": "Stijl",
    "Subscript": "Subscript",
    "Superscript": "Superscript",
    "Switch to or from fullscreen mode": "Schakelen naar of vanuit volledige schermmodus",
    "Symbols": "Symbolen",
    "System Font": "Systeemlettertype",
    "Table": "Tabel",
    "Table caption": "Tabel onderschrift",
    "Table properties": "Tabeleigenschappen",
    "Table styles": "Tabel stijlen",
    "Template": "Sjabloon",
    "Templates": "Sjablonen",
    "Text": "Tekst",
    "Text color": "Tekstkleur",
    "Text color {0}": "",
    "Text to display": "Weer te geven tekst",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "De ingevoerde URL lijkt op een e-mailadres. Wilt u er het vereiste voorvoegsel mailto: aan toevoegen?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "De ingevoerde URL lijkt op een externe link. Wilt u er het vereiste voorvoegsel http:// aan toevoegen?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "De ingevoerde URL lijkt op een externe link. Wilt u er het vereiste voorvoegsel https:// aan toevoegen?",
    "Title": "Titel",
    "To open the popup, press Shift+Enter": "Druk op Shift+Enter om de pop-up te openen",
    "Toggle accordion": "",
    "Tools": "Gereedschappen",
    "Top": "Boven",
    "Travel and Places": "Reizen en plaatsen",
    "Turquoise": "Turkoois",
    "Underline": "Onderlijnd",
    "Undo": "Ongedaan maken",
    "Upload": "Uploaden",
    "Uploading image": "Afbeelding uploaden",
    "Upper Alpha": "Hoofdletters",
    "Upper Roman": "Hoofdletters Latijns",
    "Url": "Url",
    "User Defined": "Gebruiker Gedefinieerd",
    "Valid": "Geldig",
    "Version": "Versie",
    "Vertical align": "Verticaal uitlijnen",
    "Vertical space": "Verticale ruimte",
    "View": "Tonen",
    "Visual aids": "Visuele hulpmiddelen",
    "Warn": "Waarschuwen",
    "White": "Wit",
    "Width": "Breedte",
    "Word count": "Aantal woorden",
    "Words": "Woorden",
    "Words: {0}": "Woorden: {0}",
    "Yellow": "Geel",
    "Yes": "Ja",
    "You are using {0}": "U gebruikt {0}",
    "You have unsaved changes are you sure you want to navigate away?": "U heeft niet opgeslagen wijzigingen bent u zeker dat u de pagina wilt verlaten?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Uw browser ondersteunt geen directe toegang tot het klembord. Gelieve de CTRL+X/C/V toetsen te gebruiken.",
    "alignment": "uitlijning",
    "austral sign": "austral teken",
    "cedi sign": "cedi teken",
    "colon sign": "colon teken",
    "cruzeiro sign": "cruzeiro teken",
    "currency sign": "valuta teken",
    "dollar sign": "dollar teken",
    "dong sign": "dong teken",
    "drachma sign": "drachme teken",
    "euro-currency sign": "euro valuta teken",
    "example": "voorbeeld",
    "formatting": "opmaak",
    "french franc sign": "franse frank teken",
    "german penny symbol": "duitse pfennig teken",
    "guarani sign": "guarani teken",
    "history": "geschiedenis",
    "hryvnia sign": "hryvnia teken",
    "indentation": "inspringing",
    "indian rupee sign": "indische roepie teken",
    "kip sign": "kip teken",
    "lira sign": "lire teken",
    "livre tournois sign": "tours pond teken",
    "manat sign": "manat teken",
    "mill sign": "mill teken",
    "naira sign": "naira teken",
    "new sheqel sign": "nieuwe shekel teken",
    "nordic mark sign": "noordse mark teken",
    "peseta sign": "peseta teken",
    "peso sign": "peso teken",
    "ruble sign": "roebel teken",
    "rupee sign": "roepie teken",
    "spesmilo sign": "spesmilo teken",
    "styles": "stijlen",
    "tenge sign": "tenge teken",
    "tugrik sign": "tugrik teken",
    "turkish lira sign": "turkse lira teken",
    "won sign": "won teken",
    "yen character": "yen karakter",
    "yen/yuan character variant one": "yen/yuan karakter variant een",
    "yuan character": "yuan karakter",
    "yuan character, in hong kong and taiwan": "yuan karakter, in hong kong en taiwan",
    "{0} characters": "{0} karakters",
    "{0} columns, {1} rows": "",
    "{0} words": "{0} woorden"
});